'use strict';

var utils = require('./lib/utils');
var xpath = require('./lib/xpath');
var debugMode = require('./lib/debugMode');

var source = 'client';

var Tracker = module.exports = {};

Tracker._integrations = {
  googleTagManager: require('./integrations/googleTagManager'),
  orion: require('./integrations/orion')
};

Tracker.setDebugMode = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (debugMode.set(value)) {
    console.info('🛤 Tracker debug enabled');
  }
};

// now _action is a higher order function, so
// Tracker.track('foo', bar') is the same as
// Tracker._action('track')('foo', bar')
Tracker._action = function (action) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    if (action === 'initialise' && args[0].untracked_inputs) utils._setUntrackedIds(args[0].untracked_inputs);
    if (action === 'error' && args[0]) {
      // we get a cryptic "Script  error" with no context when the error
      // originates in a script loaded from an external origin. The best we can
      // do about these errors is manually generate a stack-trace
      if (/^Script error\.?$/.test(args[0].message)) {
        args[0].info = new Error('Cross-origin script error.').stack;
      }
    }
    if (debugMode.get()) console.info.apply(console, ['🛤', action].concat(args));
    return Object.keys(Tracker._integrations).reduce(function (acc, index) {
      var integrationArgs = args.slice();
      var integration = Tracker._integrations[index];
      var method = integration[action];
      if (method) {
        var result = method.apply(integration, integrationArgs);
        if (typeof result !== 'undefined') {
          acc[index] = result;
        }
      }
      return acc;
    }, {});
  };
};

Tracker._onClick = function (event) {
  Tracker._genericInferredEvent(Tracker, event, 'click', utils.TRACKING_TYPES.CLICK);
  var element = document.activeElement;
  if (!(utils._untrackedIds.includes(element.id) && element.tagName === 'INPUT')) {
    try {
      var selection = '' + window.getSelection();
      if (selection) Tracker.inline('capture', { name: 'get-selection', value: selection });
    } catch (err) {}
  }
};

Tracker._onChange = function (event) {
  Tracker._genericInferredEvent(Tracker, event, 'capture', utils.TRACKING_TYPES.CHANGE);
};

Tracker._onFocus = function (event) {
  Tracker._genericInferredEvent(Tracker, event, 'focus', utils.TRACKING_TYPES.FOCUS);
};

// Track bytes transferred to the browser whilst they have been on the page
Tracker._onBeforeunload = function (event) {
  var performance = window.performance;
  if (performance && typeof performance.getEntries === 'function') {
    var total = 0;
    var entries = performance.getEntries();
    for (var i = entries.length - 1; i >= 0; --i) {
      var entry = entries[i];
      if (entry && entry.transferSize) {
        total += entry.transferSize;
      }
    }
    Tracker.c('bytes-transferred', total.toString());
  }
};

Tracker._initialiseInlineEvents = function (document) {
  utils._on(document, 'click', Tracker._onClick);
  utils._on(document, 'focus', Tracker._onFocus, true); // extra param to capture
  utils._on(document, 'change', Tracker._onChange, true); // extra param to capture
  utils._on(window, 'beforeunload', Tracker._onBeforeunload);
};

// If you add a new method here you need to update render and tripapp
// where these methods are stubbed and proxied in case of ad blockers.
var actions = ['initialise', 'page', 'track', 'inline', 'error', 'addToBasket', 'removeFromBasket', 'productImpressions', 'productClick', 'productDetails', 'purchase', 'addToBooking', 'ids'];

for (var index in actions) {
  Tracker[actions[index]] = Tracker._action(actions[index]);
}

// Simplified error, save on some of the repeating boilerplate
Tracker.e = function (code, message, info, source) {
  message = '' + (message || '');
  info = '' + (info || '');
  source = source || 'client';
  Tracker.error({ code: code, message: message, info: info, source: source });
};

// Simplified auto capture, save on some of the repeating boilerplate
Tracker.c = function (name, value) {
  Tracker.inline('auto_capture', { name: name, value: value });
};

Tracker._trackError = function (event) {
  // window.onerror provides a message, unhandledrejection provides reason
  var error = event.error || event.reason || event;
  var message = error.message || utils._stringify(event);
  var info = error.stack || utils._stringify(event);
  Tracker.error({ message: message, source: source, code: 'uncaught', exception: true, info: info });
};

Tracker._genericInferredEvent = function (Tracker, event, trackingType, trackingLevel) {
  var payload = {};
  var element = utils._getElement(event);
  // To add the x_path property, the _addXPath function either generates or appends the payload.tags array.
  try {
    xpath._addXPath(trackingType, payload, element);
  } catch (error) {}

  if (utils._trackingLevel(element) & trackingLevel) {
    // logical AND
    var target = utils._getTarget(element); // this element or the parent?
    try {
      utils._elementChecks(element);
    } catch (error) {
      Tracker.error(utils._prepareErrorPayload(error.message, element));
    }
    if (target) {
      payload.name = utils._getName(target);
      payload.value = utils._getValue(target);
      payload.href = utils._getAttribute(target, 'href');

      if (trackingType === 'capture' && Boolean(utils._getAttribute(target, 'data-public'))) {
        trackingType = 'public_capture';
      }
      Tracker.inline(trackingType, payload);
    }
  }
};

Tracker.setDebugMode();
Tracker._initialiseInlineEvents(document);

utils._on(window, 'error', Tracker._trackError);
utils._on(window, 'unhandledrejection', Tracker._trackError);